/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-16 13:45:12
 * @LastEditors: linxi
 * @LastEditTime: 2025-10-17 17:20:08
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Modal, notification, Row, Spin, Steps } from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import styles from './memorandum.module.css'
import {
  getPatientMemoDeleteAsync,
  getPatientMemoListAsync,
} from './memorandumSlice'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { AddOrEditModal } from './addOrEditModal'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { MemorandumImportModal } from './importMemorandum'

interface MemorandumInfoProps {
  activeKey?: any
  toothPatient?: any
  patientId?: any
}

export const MemorandumInfo = ({
  activeKey,
  toothPatient,
  patientId,
}: MemorandumInfoProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [dataList, setDataList] = useState<any[]>([])

  const [loading, setLoading] = useState<boolean>(false)

  const [id, setId] = useState('')

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [isImportModalVisible, setIsImportModalVisible] = useState(false)

  useEffect(() => {
    if (activeKey == '13' || activeKey == '备忘录') { //都代表备忘录
      if (patientId) {
        setLoading(true)
        getPageList()
      }
    }
  }, [activeKey, patientId])

  const getPageList = () => {
    dispatch(
      getPatientMemoListAsync({
        current: 1,
        size: -1,
        patientId: patientId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setDataList(res?.records)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <div className={styles.content}>
        <Spin spinning={loading} style={{ paddingTop: '200px' }}>
          <div style={{ height: 'calc(100% - 50px)', paddingTop: '20px' }}>
            {dataList?.length ? (
              <>
                <div className={styles.stepsWrapper}>
                  {dataList?.map((v) => {
                    return (
                      <>
                        <div className={styles.stepItem}>
                          <div className={styles.stepTime}>
                            {moment(v?.createTime).format('YYYY-MM-DD') || '-'}
                            <br />
                            {moment(v?.createTime).format('HH:mm:ss')}
                          </div>
                          <div className={styles.stepDot}></div>
                          <div className={styles.stepContent}>
                            <div className={styles.stepTitleContainer}>
                              <Row className={styles.stepTitle}>
                                <Col span={20} className={styles.stepTitleText}>
                                  标题：{v?.title || '-'}
                                </Col>
                                <Col span={4}>
                                  <Row className={styles.buttonMain}>
                                    <Button
                                      type='link'
                                      onClick={() => {
                                        setIsModalVisible(true)
                                        setId(v?.id)
                                      }}
                                    >
                                      编辑
                                    </Button>
                                    <Button
                                      type='link'
                                      danger
                                      onClick={() => {
                                        Modal.confirm({
                                          centered: true,
                                          title: '确认操作',
                                          content: (
                                            <div>
                                              <ExclamationCircleFilled
                                                style={{
                                                  color: '#FFAE55',
                                                  fontSize: 18,
                                                }}
                                              />
                                              &nbsp;是否确认删除？
                                            </div>
                                          ),
                                          okText: '确认',
                                          cancelText: '取消',
                                          icon: null,
                                          onOk: () => {
                                            dispatch(
                                              getPatientMemoDeleteAsync({
                                                ids: v?.id,
                                              })
                                            )
                                              .then(unwrapResult)
                                              .then(() => {
                                                notification.success({
                                                  message: '删除成功',
                                                })
                                                getPageList()
                                              })
                                          },
                                        })
                                      }}
                                    >
                                      删除
                                    </Button>
                                  </Row>
                                </Col>
                              </Row>
                              <div className={styles.stepContentRow}>
                                <Row>内容：{v?.content || '-'}</Row>
                                <Row>记录人员：{v?.recorder || '-'}</Row>
                              </div>
                            </div>
                          </div>
                          <div className={styles.stepLine}></div>
                        </div>
                      </>
                    )
                  })}
                </div>
              </>
            ) : (
              <>
                <div className={styles.tips}>该患者暂无备忘录</div>
              </>
            )}
          </div>
        </Spin>
        <Button
          type='primary'
          style={{
            position: 'absolute',
            bottom: 20,
            left: 20,
            zIndex: 99
          }}
          onClick={() => {
            setIsModalVisible(true)
          }}
        >
          新增备忘录
        </Button>
        {activeKey === '备忘录' && (
          <Button
            type='primary'
            style={{
              position: 'absolute',
              bottom: 20,
              left: 120,
              zIndex: 99,
              marginLeft: 20,
            }}
            onClick={() => {
              // TODO: 备忘录导入
              setIsImportModalVisible(true)
            }}
          >
            备忘录导入
          </Button>
        )}
      </div>
      <AddOrEditModal
        id={id}
        patientId={patientId}
        isModalVisible={isModalVisible}
        onOk={() => {
          setIsModalVisible(false)
          setId('')
          getPageList()
        }}
        onCancel={() => {
          setIsModalVisible(false)
          setId('')
        }}
      />
      <MemorandumImportModal
        isModalVisible={isImportModalVisible}
        state={1}
        onOk={() => {
          setIsImportModalVisible(false)
          getPageList()
        }}
        onCancel={() => {
          setIsImportModalVisible(false)
        }}
      />
    </>
  )
}
